var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container",on:{"click":function($event){return _vm.showProvider()}}},[_c('h1',{staticClass:"price",style:({color:_vm.color_in_string})},[_vm._v(_vm._s(_vm.price))])])])}
var staticRenderFns = []

export { render, staticRenderFns }